import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/new-games.api';
import template from './new-games-widget.html';

// eslint-disable-next-line no-undef
@Inject('$scope', 'gettextCatalog')
class NewGamesWidgetController extends DashboardWidgetController {
  $onInit() {
    this.activeTabIdx = this.isEmptyGamesComing ? 1 : 0;
    this.isEmptyGamesComing = true;
    this.isEmptyGamesLaunched = true;
    this.gamesComing = [];
    this.gamesLaunched = [];
    this.loadDataAsync(() => Promise.all([this.getGamesComingData(), this.getGamesLaunchedData()]));
  }

  getGamesComingData() {
    return this.getGamesComing().then((result) => {
      this.isEmptyGamesComing = isEmpty(result);
      if (this.isEmptyGamesComing) {
        this.activeTabIdx = 1;
      }
    });
  }

  getGamesLaunchedData() {
    return this.getGamesLaunched().then((result) => {
      this.isEmptyGamesLaunched = isEmpty(result);
      if (this.isEmptyGamesLaunched) {
        this.activeTabIdx = 0;
      }
    });
  }

  getComingGamesLabelWithSpecifiedDate() {
    const launchDate = moment(get(this.gamesComing, '[0].distribution.launchDate')).format('MMM D');
    return `${this.gettextCatalog.getString('Coming')} ${launchDate}`;
  }

  getComingGamesLabelWithoutSpecifiedDate() {
    return `${this.gettextCatalog.getString('Coming Soon')}`;
  }

  getGamesComing() {
    return api.fetchGamesComing().then((data) => {
      this.gamesComing = data;
      this.comingGamesLabel = data.specifiedDate
        ? `${this.getComingGamesLabelWithSpecifiedDate()}`
        : `${this.getComingGamesLabelWithoutSpecifiedDate()}`;
      return Promise.resolve(this.gamesComing);
    });
  }

  getGamesLaunched() {
    return api.fetchGamesLaunched().then((data) => {
      this.gamesLaunched = data;
      return Promise.resolve(this.gamesLaunched);
    });
  }
}

export default class NewGamesWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = NewGamesWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/new-games/new-games-widget-component.js